export default String.raw`
{% include 'partials/common/date-format.html' -%}
{% assign coupon = customer-profile.CouponDetails -%}
{% assign pageQueryName = customer-profile.Coupons.PageQueryGET -%}
{% assign queries = page.QueryString | UnEscapeUri | Split: '&' -%}

{% assign pageQueryNo = 1 -%}

{% for query in queries -%}
    {% if query contains 'page=' -%}
        {% assign pageQueryNo = query | Split: '=' | Last -%}
        {% break -%}
    {% endif -%}
{% endfor -%}

<div class="customer-submenu">
    <div class="customer-submenu__header">
        <div class="navigation-header">
            <button aria-label="{{translations.Back}}" class="pure-button load-first-lvl-js parent-container-reload-js" data-template="partials/customer-profile/discounts/discounts.html" data-url="{{ page.Url }}?tab=coupons">
                <svg aria-hidden="true" width="24" height="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
                </svg>
            </button>
            {% if coupon.Code != null -%}
                {{ coupon.Code }}
            {% else -%}
                {{ translations.Coupons }}
            {% endif -%}
        </div>
    </div>
    
    <div class="eshop__table-container">
        <table>
            <colgroup>
                <col style="width:200px">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th class="id">{{ translations.Property }}</th>
                    <th>{{ translations.Value }}</th>
                </tr>
            </thead>
            <tbody>
                <tr class="row no-hover">
                    <td class="id">{{ translations.Categories }}</td>
                    <td>
                        {% if coupon.Groups == empty -%}
                            {{ translations.Com_All }}
                        {% else -%}
                            {% for group in coupon.Groups -%}
                                <a href="{{ page.BaseHref }}{{ group.Url }}" target="_blank" rel="noopener noreferrer">{{group.Name}}</a>{% unless forloop.last -%}, {% endunless -%}
                            {% endfor -%}
                        {% endif -%}
                    </td>
                </tr>
                <tr class="row no-hover">
                    <td class="id">{{ translations.Value }}</td>
                    <td>
                        {% if coupon.Type == 0 -%}
                            {{ coupon.Discount | Normalize }} %
                        {% elseif coupon.Type == 1 -%}
                            {{ coupon.Discount | ToPrice }} {{ currencyExt }}
                        {% elseif coupon.Type == 2 -%}
                            {{ translations.FreeDelivery }}
                        {% elseif coupon.Type == 3 -%}
                            {{ translations.DeliveryDiscount }} {{ coupon.Discount | ToPrice }} {{ currencyExt }}
                        {% elseif coupon.Type == 4 -%}
                            {{ translations.DeliveryDiscount }} {{ coupon.Discount | Normalize }} %
                        {% endif -%}
                    </td>
                </tr>
                {% if coupon.ProductsMinimumTotalValue > 0 -%}
                <tr class="row no-hover">
                    <td class="id">{{ translations.MinimumValue }}</td>
                    <td>{{coupon.ProductsMinimumTotalValue | ToPrice}} {{currencyExt}}</td>
                </tr>
                {% endif -%}
                {% if coupon.DateTill -%}
                <tr class="row no-hover">
                    <td class="id">{{ translations.Validity }}</td>
                    <td>
                        {{ coupon.DateTill | Date:dateFormat }}
                    </td>
                </tr>
                {% endif -%}
            </tbody>
        </table>
    </div>
</div>

<div class="during-ajax-modal-js during-ajax-modal hidden-js">
    <div class="loader big"></div>
</div>
`